<div class="container-fluid">
  <div class="employeePage">
    <div class="card cardOne mt-5">
      <div class="card-body">
        <div class="employeeHead">
          <div class="leftColom">
            <h6 class="employeeDetails">Employee Detail</h6>
          </div>
          <div class="row rightColom">
            <!-- <div class="col-md-2"></div> -->
            <!-- <div class=""> -->
            <button class="btn thisYear">
              <i class="fa-regular fa-user pe-2"></i>This Year<i
                class="fa-solid fa-chevron-down ps-2"
              ></i>
            </button>
            <!-- </div> -->
            <!-- <div class=""> -->
            <button class="btn download">
              <i class="fa-solid fa-download pe-2"></i>Download
            </button>
            <!-- </div> -->
          </div>
        </div>
        <!-- Two -->
        <div class="row">
          <div class="col-md-3 row m-0 empDtls">
            <div class="col-md-4 p-0 align-content-center">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRo6wCUSmJEK9kC5KVqmQczHMH3OMcc_9BTTQ&s"
                alt="No Image"
                class="employeeImage img-fluid"
              />
            </div>
            <div class="col-md-8 role">
              <h5 class="userName">{{ userDetail.firstname }}</h5>
              <h6 class="empKey">Role</h6>
              <p class="roleData">{{ userDetail?.roledata?.role }}</p>
            </div>
          </div>
          <div class="col-md-3 alignEnd">
            <h5></h5>
            <h6 class="empKey">Employee ID</h6>
            <p class="roleData">{{ userDetail.employeecode }}</p>
          </div>
          <div class="col-md-3 alignEnd">
            <h5></h5>
            <h6 class="empKey">Phone Number</h6>
            <p class="roleData">{{ userDetail.mobile }}</p>
          </div>
          <div class="col-md-3 alignEnd">
            <h5></h5>
            <h6 class="empKey">Email Address</h6>
            <p class="roleData">{{ userDetail.email }}</p>
          </div>
        </div>
        <!-- Row3 -->
        <div class="row my-4">
          <div class="col-md-3 attendanceParent">
            <div class="row details">
              <div class="alignCenter">
                <span class="attendanceIcon"
                  ><img
                    src="assets/img/Attendence Icon/vector.svg"
                    alt="No Image"
                /></span>
              </div>
              <div class="p-0 checkingTime">
                <h5>{{ userAttendance?.totalAttendanceCount }}</h5>
                <p class="attDtl">Total Attendance</p>
              </div>
            </div>
          </div>
          <div class="col-md-3 attendanceParent">
            <div class="row details">
              <div class="alignCenter">
                <span class="attendanceIcon"
                  ><img
                    src="assets/img/Attendence Icon/check-in.svg"
                    alt="No Image"
                /></span>
              </div>
              <div class="p-0 checkingTime">
                <h5>{{ userAttendance?.averageCheckInTime }}</h5>
                <p class="attDtl">Avg Check in Time</p>
              </div>
            </div>
          </div>
          <div class="col-md-3 attendanceParent">
            <div class="row details">
              <div class="alignCenter">
                <span class="attendanceIcon"
                  ><img
                    src="assets/img/Attendence Icon/checkout.svg"
                    alt="No Image"
                /></span>
              </div>
              <div class="p-0 checkingTime">
                <h5>{{ userAttendance?.averageCheckOutTime }}</h5>
                <p class="attDtl">Avg Check out Time</p>
              </div>
            </div>
          </div>
          <div class="col-md-3 attendanceParent">
            <div class="row details">
              <div class="alignCenter">
                <span class="attendanceIcon"
                  ><img
                    src="assets/img/Attendence Icon/vector.svg"
                    alt="No Image"
                /></span>
              </div>
              <div class="p-0 checkingTime">
                <h5>{{ userAttendance?.leaveTaken }}</h5>
                <p class="attDtl">Leave Taken</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card cardOne mt-5">
      <div class="card-body">
        <div class="attendanceHistoryParent">
          <div>
            <h6 class="employeeDetails">Attendance History</h6>
          </div>
          <div class="row">
            <div class="col-md-3 sortParent">
              <button class="btn sort">Sort</button>
            </div>
            <div class="col-md-3 filterParent">
              <button class="btn sort">Filters</button>
            </div>
            <div class="col-md-6 dateTable">
              <input
                type="date"
                class="form-control sort"
                [(ngModel)]="selectedDate"
                value="{{ currentDate }}"
                (ngModelChange)="onDateChange()"
                id="dateInput"
              />
            </div>
          </div>
        </div>

        <!-- Calendar -->
        <div class="row">
          <div class="py-3 monthParent" style="background-color: #f0f5f7">
            <div class="d-flex">
              <div class="col-md-6 mb-2 fs-5 month">
                {{ selectedMonthText }} {{ currentMonth[0] }}st -
                {{ currentMonth.length }}st
              </div>
              <div class="col-md-6 mb-2 fs-5 text-end">
                <span class="present_parent">
                  <i class="fa-solid fa-circle-dot present"></i>Present</span
                >
                <span class="present_parent"
                  ><i class="fa-solid fa-circle-dot absent"></i>Absent</span
                >
                <span class="present_parent"
                  ><i class="fa-solid fa-circle-dot lop"></i>LOP</span
                >
                <span class="present_parent"
                  ><i class="fa-solid fa-circle-dot holiday"></i>Holiday</span
                >
              </div>
            </div>
            <div class="row col-md-12">
              <div class="col-md-6 text-start pay startPayParent">
                <span class="startPay">Start of pay: </span
                ><span class="fw-bold"
                  >{{ currentMonth[0] }}st {{ selectedMonthText }}</span
                >
              </div>
              <div class="col-md-6 pay endPayParent">
                <span class="startPay">End of pay:</span
                ><span class="fw-bold"
                  >{{ this.currentMonth.length }}st
                  {{ selectedMonthText }}</span
                >
              </div>
            </div>
            <div class="col-md-12 currentMonth">
              <ng-container *ngFor="let item of fullMonthData" class="row">
                <span *ngIf="item.status == 'On Time'" [ngClass]="'on-time'">
                  {{ item.date | date : "d" }}
                </span>
                <span
                  *ngIf="item.status == 'Late Check-In'"
                  [ngClass]="'late-check-in'"
                  >{{ item.date | date : "d" }}</span
                >
                <span *ngIf="item.status == ''" [ngClass]="'empty'">{{
                  item.date | date : "d"
                }}</span>
                <span *ngIf="item.status == 'Late'" [ngClass]="'empty'">{{
                  item.date | date : "d"
                }}</span>
                <span *ngIf="item.status == 'Leave'" [ngClass]="'empty'">{{
                  item.date | date : "d"
                }}</span>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- Checking User Datas -->
        <div class="row">
          <div
            class="col-md-4 my-3 dailyDateParent"
            *ngFor="let item of attendanceDataFetch"
          >
            <div class="dailyDate">
              <div class="row mb-4">
                <div class="col-md-6 text-start date">
                  {{ item.attendancedate | date : "MMM dd, yyyy" }}
                </div>
                <div class="col-md-6 text-end onTime">
                  <span *ngIf="item.status == 'On Time'" class="success">
                    <img
                      src="../../../../../../assets/img/Attendence Icon/present.svg"
                      alt="on-time"
                      class="img-fluid"
                    />
                    {{ item.status }}
                  </span>
                  <span *ngIf="item.status == 'Late Check-In'" class="danger">
                    <img
                      src="../../../../../../assets/img/Attendence Icon/absent.svg"
                      alt="on-time"
                      class="img-fluid"
                    />
                    {{ item.status }}
                  </span>
                  <span *ngIf="item.status == 'Early Check-In'" class="warning">
                    <img
                      src="../../../../../../assets/img/Attendence Icon/lop.svg"
                      alt="on-time"
                      class="img-fluid"
                    />
                    {{ item.status }}
                  </span>
                  <span *ngIf="item.status == 'Late'" class="warning">
                    <img
                      src="../../../../../../assets/img/Attendence Icon/lop.svg"
                      alt="on-time"
                      class="img-fluid"
                    />
                    {{ item.status }}
                  </span>
                  <span *ngIf="item.status == 'Leave'" class="warning">
                    <img
                      src="../../../../../../assets/img/Attendence Icon/lop.svg"
                      alt="on-time"
                      class="img-fluid"
                    />
                    {{ item.status }}
                  </span>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6 inTime">Check In Time</div>
                <div class="col-md-6 inTime">Check out Time</div>
              </div>
              <div class="row mb-1">
                <div class="col-md-6 time">
                  {{ item.checkintime | date : "h:mm a" : "UTC" }}
                </div>
                <div class="col-md-6 time">
                  {{ item.checkouttime | date : "h:mm a" : "UTC" }}
                </div>
              </div>
            </div>
          </div>
          <nav aria-label="Page navigation example">
            <ul class="pagination">
              <!-- Previous Button -->
              <li class="page-item" [class.disabled]="currentPage === 0">
                <a
                  class="page-link"
                  (click)="changePage(currentPage - 1)"
                  aria-label="Previous"
                >
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>

              <!-- Page Numbers -->
              <li
                class="page-item"
                *ngFor="let page of pageNumbers"
                [class.active]="page === currentPage"
              >
                <a class="page-link" (click)="changePage(page)">{{
                  page + 1
                }}</a>
              </li>

              <!-- Next Button -->
              <li
                class="page-item"
                [class.disabled]="currentPage === totalPages - 1"
              >
                <a
                  class="page-link"
                  (click)="changePage(currentPage + 1)"
                  aria-label="Next"
                >
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>
